var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import classnames from 'classnames';
import { Scroller } from '@alife/simple-ui';
import SessionItem from '../session-item';
import Icon from '@alife/next-icon';
var SessionList = (function (_super) {
    __extends(SessionList, _super);
    function SessionList(props) {
        var _this = _super.call(this, props) || this;
        _this.hasMore = true;
        _this.saveScroller = function (scroller) {
            _this.scroller = scroller;
        };
        _this.onScoll = function (data) {
            requestAnimationFrame(function () { return _this.calcVisibleItem(data); });
        };
        _this.calcVisibleItem = function (data) {
            if (data === void 0) { data = {}; }
            if (!_this.scroller) {
                return;
            }
            var scrollTop = data.top || _this.scroller.scrollContentDom.scrollTop;
            var contentHeight = _this.scroller.selfDom.clientHeight;
            var _a = _this.props, sessionItemHeight = _a.sessionItemHeight, sessionList = _a.sessionList, loading = _a.loading;
            var viewCount = Math.ceil(contentHeight / sessionItemHeight);
            var minIndex = Math.round(scrollTop / sessionItemHeight) - _this.props.preFetchCount;
            var maxIndex = minIndex + viewCount + _this.props.preFetchCount;
            var _b = _this.state, visiableMinIndex = _b.visiableMinIndex, visiableMaxIndex = _b.visiableMaxIndex;
            if (visiableMinIndex !== minIndex || visiableMaxIndex != maxIndex) {
                _this.setState({
                    visiableMinIndex: minIndex,
                    visiableMaxIndex: maxIndex,
                    sessionHeight: sessionList.length * sessionItemHeight
                });
            }
            if (_this.hasMore && maxIndex > sessionList.length && !loading) {
                _this.props.loadMore();
            }
        };
        _this.state = {
            visiableMinIndex: 0,
            visiableMaxIndex: 10
        };
        return _this;
    }
    SessionList.prototype.componentDidMount = function () {
        this.calcVisibleItem();
    };
    SessionList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        var nextSessions = nextProps.sessionList;
        var _a = this.props, currSessions = _a.sessionList, sessionItemHeight = _a.sessionItemHeight;
        if (nextSessions.length !== currSessions.length) {
            this.calcVisibleItem();
            this.setState({ sessionHeight: nextSessions.length * sessionItemHeight });
            requestAnimationFrame(function () {
                if (!_this.scroller) {
                    return;
                }
                _this.scroller.updateScrollBar();
            });
        }
    };
    SessionList.prototype.componentDidUpdate = function (prevProps) {
        var prevSessionLength = prevProps.sessionList.length;
        var currSessionLength = this.props.sessionList.length;
        if (prevProps.loading && !this.props.loading && prevSessionLength === currSessionLength) {
            this.hasMore = false;
        }
        if (this.scroller && this.scroller.scrollToLastTop && prevProps.activeSessionId === this.props.activeSessionId) {
            this.scroller.scrollToLastTop();
        }
    };
    SessionList.prototype.render = function () {
        var _a = this.props, sessionList = _a.sessionList, draftMap = _a.draftMap, loading = _a.loading, openSession = _a.openSession, activeSessionId = _a.activeSessionId, _b = _a.locale, locale = _b === void 0 ? {} : _b, deleteSession = _a.deleteSession, IconDelete = _a.IconDelete, _c = _a.keyword, keyword = _c === void 0 ? '' : _c, avatarFallbackUrl = _a.avatarFallbackUrl, sessionItemHeight = _a.sessionItemHeight;
        var _d = this.state, visiableMinIndex = _d.visiableMinIndex, visiableMaxIndex = _d.visiableMaxIndex, sessionHeight = _d.sessionHeight;
        return (React.createElement(Scroller, { ref: this.saveScroller, className: "session-list", freezing: loading, onScroll: this.onScoll, customScrollBar: true },
            React.createElement("div", { className: "virtualize-box", style: { height: sessionHeight } }, sessionList.map(function (item, index) {
                var itemSessionId = item.sessionId;
                var draftText = draftMap.get(itemSessionId) || '';
                return visiableMinIndex <= index && index <= visiableMaxIndex ? (React.createElement(SessionItem, { key: itemSessionId, item: item, draft: draftText, active: itemSessionId === activeSessionId, onClick: function () { openSession(item); }, locale: locale, IconDelete: IconDelete, deleteSession: deleteSession, keyword: keyword, avatarFallbackUrl: avatarFallbackUrl, top: index * sessionItemHeight })) : null;
            })),
            React.createElement("div", { className: classnames('loading-bar', { invisible: !loading }) },
                React.createElement(Icon, { type: "loading", size: "large" }))));
    };
    SessionList.defaultProps = {
        preFetchCount: 2,
        sessionItemHeight: 64
    };
    return SessionList;
}(React.Component));
export default SessionList;
//# sourceMappingURL=index.js.map